module.exports = __webpack_public_path__ + "assets/chevron-right-white.1ac73e21.svg";